import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({ providedIn: 'root' })
export class AdminDashboardService {
  constructor(private hs: HttpService) {}

  async get_dashboard(params: any) {
    return this.hs.get('/assessment/get-admin-dashboard', params);
  }
}
